exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.sticky-quotation-wrapper {\n    position: fixed;\n    top: 25vh;\n    right: 0;\n    z-index: 10;\n}\n.sticky-button {\n    font-weight: 600;\n    font-size: 1.3rem;\n    transform: rotate(90deg) translateX(100%);\n    transform-origin: 100% 0%;\n}\n@media only screen and (max-width: 600px) {\n.sticky-quotation-wrapper {\n        position: fixed;\n        top: inherit;\n        bottom: -8px;\n        width: 100%;\n        right: 0;\n        z-index: 1000;\n}\n.sticky-button {\n        font-weight: 600;\n        font-size: 1.3rem;\n        transform: inherit;\n        transform-origin: 100% 0%;\n}\n}\n", ""]);

// exports
